import { ExecContext } from './exec-context.js';
import { ScopedLogger } from '../logging/index.js';
import { NoScopedLogger } from '../logging/no-scoped-logger.js';
import { NoProgressReport, ProgressReport } from '../progress/index.js';
import { TraceContext } from '../tracing/index.js';
export class ExecContextBuilder {
    _configService = undefined;
    _progress = NoProgressReport.instance;
    _traceContext = undefined;
    withTraceContext(traceContext) {
        this._traceContext = traceContext;
        return this;
    }
    withProgress() {
        this._progress = new ProgressReport();
        return this;
    }
    withLogger(config) {
        this._configService = config;
        return this;
    }
    build() {
        let traceContext = this._traceContext;
        if (!traceContext) {
            traceContext = TraceContext.new();
        }
        let logger = NoScopedLogger.instance;
        if (this._configService) {
            logger = new ScopedLogger(this._configService, traceContext);
        }
        return new ExecContext(traceContext, logger, this._progress);
    }
}
//# sourceMappingURL=exec-context-builder.js.map